import React from "react";
import "./NoRecordFound.scss";
import Image from "../../../image/Image";
import { AppIcons } from "../../../../data/appIcons";

const NoRecordFound = () => {
  return (
    <div className="record-not-found">
      <Image imagePath={AppIcons.noRecordImg} altText="Record Not Found" />
      <h5>No Record Found</h5>
    </div>
  );
};

export default NoRecordFound;
